import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { useAuthStore } from "../../store/auth";

interface PublicOnlyRouteProps {
  children: ReactNode;
}

export const PublicOnlyRoute: React.FC<PublicOnlyRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { user } = useAuthStore((state) => state);

  // FIX: Must check both token AND user to match ProtectedRoute logic, otherwise routing loop occurs
  if (isAuthenticated && user) {
    // Redirect user to the destination path from redirect param, or fallback to root
    const params = new URLSearchParams(window.location.search);
    const redirectParam = params.get("redirect");
    // Restrict to relative in-app paths — reject absolute URLs and protocol-relative paths
    // to prevent open-redirect attacks.
    const redirectTo = redirectParam && redirectParam.startsWith("/") && !redirectParam.startsWith("//") ? redirectParam : "/";
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
